import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import AuthService from "@/services/authService.js";

const user = AuthService.isAuthenticated()
  ? AuthService.getEmailAddress()
  : null;

const connectionString = import.meta.env.VITE_INSIGHTS_CONNECTION_STRING;
const appInsights = new ApplicationInsights({
  config: {
    connectionString: connectionString,
    instrumentationKey: "",
    accountId: user,
    loggingLevelConsole: 1,
    enableAutoRouteTracking: true,
    disableTelemetry: !connectionString,
    disableInstrumentationKeyValidation: !connectionString,
    maxAjaxCallsPerView: 1500,
  },
});

await Promise.resolve(() => {
  // eslint-disable-next-line no-console
  console.debug("[AppInsight] Awaiting Promise");
  appInsights.loadAppInsights();
  // eslint-disable-next-line no-console
  console.debug("[AppInsight] Loaded");
  appInsights.trackPageView();
  // eslint-disable-next-line no-console
  console.debug("[AppInsight] Track Page View");

  appInsights.addTelemetryInitializer((envelope) => {
    const baseData = envelope.baseData;
    const MSGraph =
      baseData.target.includes("https://graph.microsoft.com") &&
      baseData.target.includes("/photo");

    if (MSGraph && baseData?.responseCode && baseData.responseCode === 404) {
      baseData.success = true;
    }

    envelope.tags["ai.application.ver"] = import.meta.env.VITE_VERSION;
  });
  // eslint-disable-next-line no-console
  console.debug("[AppInsight] Set Configuration For Missing Profile Photos");
});

// eslint-disable-next-line no-console
console.debug("[AppInsight] Promise Resolved");

export default appInsights;
